import Receipt from './Reciept';

export default Receipt;
